var render, staticRenderFns
import script from "./ViewSelector.vue?vue&type=script&lang=js&"
export * from "./ViewSelector.vue?vue&type=script&lang=js&"
import style0 from "./ViewSelector.vue?vue&type=style&index=0&id=7ed77f30&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ed77f30",
  null
  
)

component.options.__file = "ViewSelector.vue"
export default component.exports